// material-ui

import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

// styles
const LoaderWrapper = styled("div")({
  position: "fixed",
  top: "50%",
  left: "50%",
  zIndex: 1301,
  width: "100%",
});

const OverlayWrapper = styled("div")({
  position: "fixed",
  width: "100%",
  height: "100%",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  backgroundColor: "rgba(0,0,0,0.2)",
});

// ==============================|| LOADER ||============================== //

const Spinner = () => (
  <LoaderWrapper>
    <OverlayWrapper />
    <CircularProgress color="primary" />
    <Box>Loading...</Box>
  </LoaderWrapper>
);

export default Spinner;
